import { render } from "./_filename.vue?vue&type=template&id=3095e320&lang=pug"
import script from "./_filename.vue?vue&type=script&lang=js"
export * from "./_filename.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__